import { render, staticRenderFns } from "./PostTickets.vue?vue&type=template&id=5c973059&"
import script from "./PostTickets.vue?vue&type=script&lang=js&"
export * from "./PostTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports